import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.admin');
import { switchPortalMode } from "src/libs/portal-mode-transition";
import { OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.admin/view.scss */
/* src/app/component.nav.admin/view.scss: no such file or directory */`],
})
export class ComponentNavAdminComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    public communityID: string | null = null;
    public isGroupContext = false;

    // The sidebar always represents the community; group tabs live in the detail page.
    public comm_menus = [
        { label: '정보', path: 'info', icon: 'Info' },
        { label: '연구그룹', path: 'group', icon: 'Group' },
        { label: '연구자', path: 'user', icon: 'User' }
    ];

    public showCommSubmenu = false;
    public menusReady = false;
    public communityExpanded = false;
    private communityMenuPath: string | null = null;
    public isCommunityPage = false;
    private navSub: any;
    private contextRequest = 0;
    public selectedCommunity: any;
    public contextLoading = false;

    public adminMenu = [
        { id: 'group-mail-mgmt', label: '그룹 메일', icon: 'Envelope', mainPath: '/admin/group-mail', path: '/admin/group-mail', category: 'support' },
        { id: 'logs-mgmt', label: '운영 로그', icon: 'Clipboard', mainPath: '/admin/logs', path: '/admin/logs', category: 'support' },
        { id: 'community-mgmt', label: '커뮤니티', icon: 'Building', mainPath: '/admin/community', path: '/admin/community', category: 'research' },
        { id: 'ticket-mgmt', label: '티켓팅', icon: 'Ticket', mainPath: '/admin/ticketing', path: '/admin/ticketing', category: 'support' },
        { id: 'faq-mgmt', label: 'FAQ', icon: 'Question', mainPath: '/admin/faq', path: '/admin/faq', category: 'support' },
        { id: 'notice-mgmt', label: '공지사항', icon: 'Megaphone', mainPath: '/admin/notice', path: '/admin/notice', category: 'content' },
        { id: 'manual-mgmt', label: '매뉴얼', icon: 'FileLines', mainPath: '/admin/manual', path: '/admin/manual', category: 'support' },
        { id: 'image-mgmt', label: '매뉴얼 이미지', icon: 'Image', mainPath: '/admin/image', path: '/admin/image', category: 'support' },
        { id: 'research-mgmt', label: '성과', icon: 'Chart', mainPath: '/admin/research', path: '/admin/research', category: 'content' },
        { id: 'board-mgmt', label: '게시판', icon: 'Message', mainPath: '/admin/board', path: '/admin/board', category: 'content' },
        { id: 'storage-mgmt', label: '스토리지', icon: 'Storage', mainPath: '/admin/storage', path: '/admin/storage', category: 'research' },
        { id: 'request-mgmt', label: '승인 요청', icon: 'Envelope', mainPath: '/admin/request', path: '/admin/request', category: 'research' },
        { id: 'user-mgmt', label: '사용자', icon: 'Users', mainPath: '/admin/users', path: '/admin/users', category: 'research' },
    ];

    public categories: Record<string, { label: string }> = {
        research: { label: '연구 관리' },
        support: { label: '기술지원' },
        content: { label: '콘텐츠' },
    };
    public categoryKeys = Object.keys(this.categories);

    public session: any;
    public mode: any;

    public community_link: string = '/admin/community';

    public userInfo: any = {
        account_name: '',
        email: '',
        roles: [],
        community_manager: false
    };

    @ViewChild('accountRoot') private accountRoot?: ElementRef<HTMLElement>;
    @ViewChild('accountTrigger') private accountTrigger?: ElementRef<HTMLButtonElement>;
    public accountMenuOpen = false;

    public toggleAccountMenu() {
        this.accountMenuOpen = !this.accountMenuOpen;
        this.cdr.detectChanges();
        if (this.accountMenuOpen) {
            this.accountRoot?.nativeElement.querySelector<HTMLElement>('nav a')?.focus({ preventScroll: true });
        }
    }

    public closeAccountMenu(restoreFocus = false) {
        if (!this.accountMenuOpen) return;
        this.accountMenuOpen = false;
        this.cdr.detectChanges();
        if (restoreFocus) this.accountTrigger?.nativeElement.focus({ preventScroll: true });
    }

    public onAccountKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape' || !this.accountMenuOpen) return;
        event.preventDefault();
        event.stopPropagation();
        this.closeAccountMenu(true);
    }

    public onAccountFocusout(event: FocusEvent) {
        if (!this.accountRoot?.nativeElement.contains(event.relatedTarget as Node)) this.closeAccountMenu();
    }

    @HostListener('document:pointerdown', ['$event'])
    public onOutsideAccountClick(event: PointerEvent) {
        if (!this.accountRoot?.nativeElement.contains(event.target as Node)) this.closeAccountMenu();
    }

    @HostListener('window:resize')
    public onAccountResize() {
        this.closeAccountMenu();
    }

    public async switchMode(event: MouseEvent, path: string) {
        try {
            await switchPortalMode(event, this.router, path);
        } catch (_) {
            await this.service.alert.error('화면을 전환하지 못했습니다. 다시 시도해주세요.');
        }
    }

    public get canSwitchMode(): boolean {
        return this.session?.membership === 'admin'
            && this.session.role !== 'admin' && !!this.session.community_id;
    }

    public get managementPath(): string[] {
        return this.session?.role === 'admin'
            ? ['/admin/community']
            : ['/admin/community', this.session?.community_id, 'info'];
    }

    public get isServiceManager(): boolean {
        return this.session?.role !== 'admin'
            && (this.session?.role === 'manager' || this.userInfo.community_manager);
    }

    public get communityName(): string {
        return this.selectedCommunity || (String(this.communityID) === String(this.session?.community_id)
            ? this.session?.job_title || '' : '');
    }

    public get contextMenus() {
        return this.isServiceManager
            ? ['info', 'user', 'group'].map(path => this.comm_menus.find(menu => menu.path === path)!)
            : this.comm_menus;
    }

    public async toggleCommunityMenu() {
        this.communityExpanded = !this.communityExpanded;
        this.cdr.detectChanges();
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership("admin", "/");
        this.session = this.service.auth.session;
        const contextReady = this.updateFromUrl();
        await this.roles();
        if (this.isServiceManager && !this.communityID) await this.updateFromUrl();
        if (this.session?.admin_switch_origin) this.adminMenu = this.adminMenu.filter(item => item.id !== 'group-mail-mgmt');
        if (this.session.role !== 'admin') this.adminMenu = this.adminMenu.filter(item => !['user-mgmt', 'logs-mgmt'].includes(item.id));
        if (this.session.role !== 'admin' && !this.userInfo.community_manager) this.adminMenu = this.adminMenu.filter(item => !['request-mgmt', 'group-mail-mgmt'].includes(item.id));

        if (this.session?.role === 'admin') {
            this.categories.research.label = '운영 관리';
            this.adminMenu.find(item => item.id === 'community-mgmt').label = '커뮤니티 관리';
            this.adminMenu.find(item => item.id === 'user-mgmt').label = '전체 사용자';
            this.community_link = '/admin/community';
        } else {
            this.community_link = `/admin/community/${this.session.community_id}/info`;
            this.adminMenu = this.adminMenu.filter(item => item.id !== 'user-mgmt');
            if (this.isServiceManager) {
                const sections = [
                    { key: 'accounts', label: '계정·커뮤니티 관리', items: ['community-mgmt', 'request-mgmt'] },
                    { key: 'operations', label: '서비스 운영', items: ['group-mail-mgmt', 'ticket-mgmt', 'storage-mgmt'] },
                    { key: 'content', label: '콘텐츠 관리', items: ['notice-mgmt', 'faq-mgmt', 'manual-mgmt', 'image-mgmt', 'research-mgmt', 'board-mgmt'] }
                ];
                this.categories = Object.fromEntries(sections.map(section => [section.key, { label: section.label }]));
                this.categoryKeys = sections.map(section => section.key);
                // Reorder only the menus already allowed for this account.
                this.adminMenu = sections.flatMap(section => section.items.flatMap(id => {
                    const item = this.adminMenu.find(menu => menu.id === id);
                    return item ? [{ ...item, category: section.key }] : [];
                }));
            }
        }

        this.menusReady = true;
        await this.service.render();

        // ✅ URL 변경 반응
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => {
                this.accountMenuOpen = false;
                // 비동기지만 기다릴 필요는 없음
                this.updateFromUrl();
            });

        // 초기 실행
        await contextReady;
        await this.service.render();
    }

    public ngOnDestroy() {
        this.contextRequest++;
        this.navSub?.unsubscribe();
    }

    public async roles() {
        const { code, data } = await wiz.call("roles");
        if (code != 200) return await this.service.alert.error("Error!");
        this.userInfo = data;
        await this.service.render();
    }

    private async updateFromUrl() {
        const request = ++this.contextRequest;
        const url = this.router.url.split(/[?#]/)[0];
        const segments = url.split('/').filter(Boolean);
        this.isCommunityPage = segments[0] === 'admin' && segments[1] === 'community';
        if (this.communityMenuPath !== url) {
            this.communityExpanded = this.isCommunityPage;
            this.communityMenuPath = url;
        }
        const routeCommunity = this.isCommunityPage && segments[2] && !['new', 'all'].includes(segments[2]) ? segments[2] : null;
        const communityID = this.session && this.session.role !== 'admin'
            ? this.session.community_id : routeCommunity;
        if (communityID) {
            const groupContext = this.isCommunityPage && segments.length >= 5 && ['info', 'user'].includes(segments[4]);
            // Keep the context DOM mounted between tabs. Clear names only when identity changes.
            if (this.communityID !== communityID) this.selectedCommunity = null;
            this.communityID = communityID;
            this.isGroupContext = groupContext;
            this.mode = groupContext ? segments[4] : segments[3];
            this.showCommSubmenu = true;
            this.contextLoading = true;
            try {
                const community = await wiz.call('load', { id: communityID });
                if (request !== this.contextRequest) return;
                if (community.code === 200 && community.data?.name) this.selectedCommunity = community.data.name;
            } catch (error) {
                // Preserve the current context and usable route links during a transient failure.
            } finally {
                if (request === this.contextRequest) this.contextLoading = false;
            }
        } else {
            this.showCommSubmenu = false;
            this.contextLoading = false;
            this.selectedCommunity = null;
            this.communityID = null;
            this.isGroupContext = false;
            this.mode = null;
        }
        if (request === this.contextRequest) await this.service.render();
    }

    public contextPath(menu: string) {
        return `/admin/community/${this.communityID}/${menu}`;
    }

    public isContextActive(menu: string) {
        return (menu === 'group' && this.isGroupContext) || this.isActive(this.contextPath(menu));
    }

    public getAdminItemsBy(categoryKey: string) {
        return this.adminMenu.filter(i => i.category === categoryKey);
    }

    public isActive(link: string | string[]) {
        const path = this.router.url.split(/[?#]/)[0];
        const links = Array.isArray(link) ? link : [link];
        return links.some(link => !!link && (path === link || path.startsWith(link + '/')));
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            Ticket: 'fa-solid fa-ticket',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Grip: 'fa-solid fa-grip',
            Clipboard: 'fa-solid fa-clipboard',
            Question: 'fa-solid fa-clipboard-question',
            FileLines: 'fa-solid fa-file-lines',
            Group: 'fa-solid fa-users-viewfinder',
            Rectangle: 'fa-solid fa-users-rectangle',
            Wrench: 'fa-solid fa-screwdriver-wrench',
            Chart: 'fa-solid fa-chart-column',
            Envelope: 'fa-solid fa-envelope-circle-check',
            Bars: 'fa-solid fa-bars',
            Megaphone: 'fa-solid fa-bullhorn',
            Building: 'fa-solid fa-building',
            Info: 'fa-solid fa-circle-info',
            Message: 'fa-solid fa-message',
            Storage: 'fa-solid fa-box',
            Image: 'fa-solid fa-image',
            Key: 'fa-solid fa-key'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }

    public async logout() {
        sessionStorage.clear();
        window.location.href = '/auth/logout';
    }
}

export default ComponentNavAdminComponent;